module.exports = __webpack_public_path__ + "assets/img/01.2c222d3a.png";